import React, { useEffect, useState } from "react";
import { apiGet, apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { RiDeleteBin2Fill } from "react-icons/ri";
import { startCase } from "lodash";
import moment from "moment/moment";
import { useNavigate } from "react-router-dom";
const Cards = () => {
  const [list, setList] = useState([]);
const navigate = useNavigate()
  const getBank = async () => {
    const { status, data } = await apiGet(apiPath.getBankNew);
    if (status == 200) {
      if (data?.success) {
        setList(data?.results);
      }
    }
  };
  const Delete = async (id) => {
    const { status, data } = await apiPost(apiPath.deleteBank, { bankId: id });
    if (status == 200) {
      if (data?.success) {
        getBank();
      }
    }
  };
  useEffect(() => {
    getBank();
  }, []);
  return (
    <div
      id="mc-animate-container"
      className="v-base v-detail-base fade-enter-done"
    >
      <div>
        <div className="mc-header-wrap">
          <div
            id="mc-header"
            className="mc-navbar-blue mc-myWithdrawCards mc-default-header am-navbar am-navbar-light"
          >
            <div onClick={() => navigate(-1)} className="am-navbar-left" role="button">
              <span className="am-navbar-left-content">
                <span className="return_icon">
                  <svg style={{color:"black"}} className="am-icon am-icon-left am-icon-lg">
                    <use xlinkHref="#left" />
                  </svg>
                </span>
              </span>
            </div>
            <div className="am-navbar-title">My Cards</div>
            <div className="am-navbar-right" />
          </div>
          <div className="am-whitespace am-whitespace-sm mc-whitespace" />
        </div>
        <div className="my-withdraw-cards-wrap">
          <div className="my-withdraw-cards">
            <div className="my-ew-banks-wrap">
              <div className="withdraw-bank-card-ew">
                <div className="cards-title">
                  E-wallet added : {list?.length}
                </div>
                {list?.length > 0 ? (
                  <div className="cards-list">
                    {list?.map((res) => {
                      return (
                        <div
                          style={{ position: "relative" }}
                          className="EN card-item"
                        >
                          <div className="card-content">
                            <div className="item-top">
                              <div className="item-icon">
                                <img
                                  src="https://images.6440949940.com/mcs-images/bank/mcs_1696413043449_V3-MCS-CONSOLE-UPLOAD.jpg"
                                  alt
                                />
                              </div>
                              <div className="item-info">
                                <div className="bank-name">
                                  {startCase(res?.bank_name)}
                                </div>
                                <div className="bank-num">
                                  *******{res?.account_number}
                                </div>
                              </div>
                            </div>
                            <div className="item-bottom">
                              {moment(res?.createdAt).format("YYYY-MM-DD")}
                            </div>
                          </div>{" "}
                          <RiDeleteBin2Fill
                            onClick={() => Delete(res?._id)}
                            color="red"
                            size={18}
                          />
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="no-bank-card">
                    <span>Empty E-Wallet</span>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="add-card-btn rrr">
            <svg className="am-icon am-icon-card-add_ac68ae20 am-icon-md">
              <use xlinkHref="#card-add_ac68ae20" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cards;
